import { type ReactNode } from "react";

interface BlockQuoteProps {
  children: ReactNode;
  className?: string;
}

export function BlockQuote({ children, className }: BlockQuoteProps) {
  return (
    <div className={`relative w-fit ${className ?? ""}`}>
      {/* Top-left corner */}
      <span
        aria-hidden
        className="border-surface-dark absolute top-0 left-0 h-6 w-4 border-t-3 border-l-3"
      />
      {/* Top-right corner */}
      <span
        aria-hidden
        className="border-surface-dark absolute top-0 right-0 h-6 w-4 border-t-3 border-r-3"
      />
      {/* Bottom-left corner */}
      <span
        aria-hidden
        className="border-surface-dark absolute bottom-0 left-0 h-6 w-4 border-b-3 border-l-3"
      />
      {/* Bottom-right corner */}
      <span
        aria-hidden
        className="border-surface-dark absolute right-0 bottom-0 h-6 w-4 border-r-3 border-b-3"
      />

      {children}
    </div>
  );
}
